import React, { Component } from "react";
import { SESSION_STATUS } from "UTILS/Constants";
import moment from 'moment'

// Styles 
import "./MeetingTime.less";

class MeetingTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: {}, 
      seconds: 0,
      sessionStartTime: this.props.sessionStartTime,
      sessionStatus: this.props.sessionStatus,
    };
    this.startTimer = this.startTimer.bind(this);
    this.elapsedTime = this.elapsedTime.bind(this);
    this.initialStartTime = Date();
  }

  secondsToTime(secs){
    let h = Math.floor(secs / (60 * 60));
    let hh = (Math.log(h) * Math.LOG10E + 1 | 0);
    let hours = hh > 2 ? h : ('0' + Math.floor(secs / (60 * 60))).slice(-2);

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = ('0' + Math.floor(divisor_for_minutes / 60)).slice(-2);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = ('0' + Math.ceil(divisor_for_seconds)).slice(-2);

    let obj = {
      "h": hours,
      "m": minutes,
      "s": seconds
    };
    return obj;
  }

  startTimer() {
    this.state.sessionStatus !== SESSION_STATUS.CLOSED ?
      this.timer = setInterval(this.elapsedTime, 1000)
      : clearInterval(this.timer)
  }

  elapsedTime() {
    // const startTime = '2023-02-20 00:00:00'; //Sample static start date and time
    const startTime = moment(this.state.sessionStartTime ? this.state.sessionStartTime : this.initialStartTime).format();
    const timestampNow = moment(Date()).format();
    
    const newStartDate= new Date(startTime);
    const newEndDate=new Date(timestampNow);

    const seconds_ = (1000);
    let resultSeconds
    resultSeconds = Math.ceil((newEndDate.getTime() - newStartDate.getTime()) / (seconds_))

    let seconds = resultSeconds + 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
  }

  componentDidMount() {
    let timeElapsed = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeElapsed });
    this.startTimer()
  }

  render() {
    return (
      <div className="rightCornerPositionElapsedTime">
        <span>
          <span>{this.state.time.h ? this.state.time.h : '--' }</span>
          <span>:</span>
          <span>{this.state.time.m ? this.state.time.m : '--' }</span>
          <span>:</span>
          <span>{this.state.time.s ? this.state.time.s : '--' }</span>
        </span>
      </div>
    )
  }
}

export default MeetingTime;